import {validarCedula} from './validar-cedula';
export function validarRuc(ruc: string): boolean {
  if (!/^\d{13}$/.test(ruc)) return false;
  if (!ruc.endsWith("001")) return false;

  const tercerDigito = parseInt(ruc[2], 10);
  const base = ruc.substring(0, 10);

  if (tercerDigito < 6) {
    // Persona natural, validar como cédula
    return validarCedula(base);
  } else if (tercerDigito === 6) {
    // Entidad pública
    const coef = [3, 2, 7, 6, 5, 4, 3, 2];
    const digitos = base.split("").map(Number);
    let suma = 0;
    for (let i = 0; i < coef.length; i++) {
      suma += digitos[i] * coef[i];
    }
    const verificador = 11 - (suma % 11);
    const verifCalc = verificador === 11 ? 0 : verificador;
    return verifCalc === digitos[8]; // 9no dígito es el verificador
  } else if (tercerDigito === 9) {
    // Sociedad privada
    const coef = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    const digitos = base.split("").map(Number);
    let suma = 0;
    for (let i = 0; i < coef.length; i++) {
      suma += digitos[i] * coef[i];
    }
    const verificador = 11 - (suma % 11);
    const verifCalc = verificador === 11 ? 0 : verificador;
    return verifCalc === digitos[9]; // 10mo dígito es el verificador
  }

  return false;
}
